import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const DeleteRoundIcon = createIcon({
    viewBox: '0 0 100 100',
    path: (
        <>
            <Path
                fill='currentColor'
                fillRule='evenodd'
                d='M65.791 35.146c.355 0 .663.13.923.39s.39.568.39.923c0 .355-.13.663-.39.923s-.568.39-.923.39h-1.805L60.91 68.122a2.655 2.655 0 0 1-.882 1.805 2.665 2.665 0 0 1-1.866.738H41.838c-.711 0-1.333-.246-1.866-.738a2.826 2.826 0 0 1-.923-1.805l-3.035-30.352h-1.805c-.355 0-.663-.13-.923-.39-.26-.259-.39-.567-.39-.922 0-.355.13-.663.39-.923s.568-.39.923-.39h9.228v-3.568c0-.848.301-1.558.903-2.133a2.986 2.986 0 0 1 2.133-.861h7.054c.82 0 1.532.287 2.133.861.602.575.903 1.285.903 2.133v3.568h9.228zm-19.728-3.568v3.568h7.874v-3.568a.393.393 0 0 0-.123-.287.393.393 0 0 0-.287-.123h-7.054a.393.393 0 0 0-.287.123.393.393 0 0 0-.123.287zm12.263 36.299l2.994-30.106H38.68l2.994 30.106c0 .027.02.061.061.102.041.042.076.062.103.062h16.324a.2.2 0 0 0 .103-.041.138.138 0 0 0 .061-.123z'
            />
            <Path
                fill='currentColor'
                fillRule='nonzero'
                d='M50 98c26.51 0 48-21.49 48-48S76.51 2 50 2 2 23.49 2 50s21.49 48 48 48zm0 2C22.386 100 0 77.614 0 50S22.386 0 50 0s50 22.386 50 50-22.386 50-50 50z'
            />
        </>
    ),
})

DeleteRoundIcon.displayName = 'DeleteRoundIcon'
